import { render, staticRenderFns } from "./MainTags.vue?vue&type=template&id=1856092b&scoped=true"
import script from "./MainTags.vue?vue&type=script&lang=js"
export * from "./MainTags.vue?vue&type=script&lang=js"
import style0 from "./MainTags.vue?vue&type=style&index=0&id=1856092b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1856092b",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QIcon,QSpace,QBadge,QSeparator,QBtn});
